import React from 'react';
import { MapPin, Mail } from 'lucide-react';

const Footer = () => {
  const offices = [
    {
      country: 'Lithuania',
      company: '0g Baltics UAB',
      address: 'A. Goštauto g. 8-358',
      city: 'LT-01108 Vilnius'
    },
    {
      country: 'Latvia',
      company: '0g Baltics SIA',
      address: 'Elizabetes iela 31-8',
      city: 'LV-1010 Riga'
    },
    {
      country: 'Estonia',
      company: 'E2 Technologies OÜ',
      address: 'Lõõtsa tn 5',
      city: '11415 Tallinn'
    }
  ];

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        {/* Office Locations */}
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {offices.map((office, index) => (
            <div key={index} className="bg-white/5 rounded-xl p-6 border border-white/10 hover:bg-white/10 transition-colors">
              <div className="flex items-start gap-3 mb-4">
                <MapPin className="w-5 h-5 text-red-400 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-bold text-lg mb-1">{office.country}</h3>
                  <p className="text-gray-400 text-sm">{office.company}</p>
                </div>
              </div>
              <div className="text-gray-300 text-sm space-y-1">
                <p>{office.address}</p>
                <p>{office.city}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Contact Email */}
        <div className="flex items-center justify-center gap-3 mb-12 pb-12 border-b border-white/10">
          <Mail className="w-5 h-5 text-red-400" />
          <a 
            href="mailto:info@0gbaltics.com" 
            className="text-lg font-semibold hover:text-red-400 transition-colors"
          >
            info@0gbaltics.com
          </a>
        </div>

        {/* Copyright */}
        <div className="text-center text-gray-400 text-sm">
          <p>© 2025 0g Baltics. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
